import { postListEntity } from './postListEntity';
import { Dispatchable, dispatchable } from 'module/Redux';
import { MelezeApi } from 'module/Service/MelezeApi';
import { LoggerUtils } from 'module/Common';

export namespace PostListAction {
  export const fetchPostList = (): Dispatchable => {
    try {
      const prefetched = MelezeApi.getPrefetchedPostList();
      if (prefetched !== null) {
        return postListEntity.actionCreators.resolved(prefetched);
      }
    } catch (error) {
      LoggerUtils.logError(error);
      // return postListEntity.actionCreators.rejected(error);
    }
    return dispatchable([
      postListEntity.actionCreators.pending(null),
      MelezeApi.getPostList()
        .then(postList => postListEntity.actionCreators.resolved(postList))
        .catch(e => postListEntity.actionCreators.rejected(e)),
    ]);
  };
}



// WEBPACK FOOTER //
// ./src/module/Redux/PostList/PostListAction.ts